import { render, staticRenderFns } from "./ShareSet.vue?vue&type=template&id=dbe85878&scoped=true&"
import script from "./ShareSet.vue?vue&type=script&lang=js&"
export * from "./ShareSet.vue?vue&type=script&lang=js&"
import style0 from "./ShareSet.vue?vue&type=style&index=0&id=dbe85878&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbe85878",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/workspace/yx-web-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dbe85878')) {
      api.createRecord('dbe85878', component.options)
    } else {
      api.reload('dbe85878', component.options)
    }
    module.hot.accept("./ShareSet.vue?vue&type=template&id=dbe85878&scoped=true&", function () {
      api.rerender('dbe85878', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Activity/Children/BaseInfoChildren/ShareSet.vue"
export default component.exports